import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';

import MyButton from '../../util/myButton';
import LikeButton from './LikeButton';
import dayjs from 'dayjs';
import Comments from './Comments';
import CommentForm from './CommentForm';

//MUI 
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import Grid from '@material-ui/core/Grid';

//icons 
import CloseIcon from '@material-ui/icons/Close';
import UnfoldMore from '@material-ui/icons/UnfoldMore';
import ChatIcon from '@material-ui/icons/Chat';

//redux
import { connect } from 'react-redux';
import { getSoundOff, clearErrors } from '../../redux/actions/dataActions';


const Link = require('react-router-dom').Link;

const styles = (theme) => ({
    ...theme.spread,
    profileImage: {
        maxWidth: 200,
        height: 200,
        borderRadius: '50%',
        objectFit: 'cover'
    },
    dialogContent: {
        padding: 20
    },
    closeButton: {
        position: 'absolute',
        left: '90%'
    },
    expandButton: {
        position: 'absolute',
        left: '90%'
    },
    spinnerDiv: {
        textAlign: 'center',
        marginTop: 50,
        marginBottom: 50
    }
});


export class SoundOffDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            oldPath: '',
            newPath: ''
        };
    }

    handleOpen = () => {
        let oldPath = window.location.pathname;
        const { userHandle, soundOffId } = this.props;
        const newPath = `/users/${userHandle}/soundoff/${soundOffId}`;
        if (oldPath === newPath) {
            oldPath = `users/${userHandle}`;
        }
        window.history.pushState(null, null, newPath);
        this.setState(() => {
            return {
                open: true,
                oldPath,
                newPath
            }
        });
        this.props.getSoundOff(this.props.soundOffId);
    }
    handleClose = () => {
        window.history.pushState(null, null, this.state.oldPath);
        this.setState(() => {
            return {
                open: false
            }
        })
        this.props.clearErrors();
    }
    componentDidMount() {
        if (this.props.openDialog) {
            this.handleOpen();
        }
    }

    render() {
        const { classes, soundOff: { soundOffId, body, createdAt, likeCount, commentCount, userImg, userHandle, comments }, UI: { loading } } = this.props;


        const dialogMarkup = loading ? (
            <div className={classes.spinnerDiv}>
                <CircularProgress size={200} thickness={2} />
            </div>
        ) : (
                <Grid container spacing={16}>
                    <Grid item sm={5}>
                        <img src={userImg} alt='Profile' className={classes.profileImage} />
                    </Grid>
                    <Grid item sm={7}>
                        <Typography component={Link} color='primary' variant='h5' to={`/users/${userHandle}`} >
                            @{userHandle}
                        </Typography>
                        <hr className={classes.invisibleHR} />
                        <Typography variant='body2' color='textSecondary'  >
                            {dayjs(createdAt).format('h:mm a, MMMM DD YYYY')}
                        </Typography>
                        <hr className={classes.invisibleHR} />
                        <Typography variant='body1'>
                            {body}
                        </Typography>
                        <LikeButton soundOffId={soundOffId} soundOff={this.props.soundOff} />
                        <span>{likeCount} Likes</span>
                        <MyButton tip='Comments'>
                            <ChatIcon color='primary ' />
                        </MyButton>
                        <span>{commentCount} Comments</span>
                    </Grid>
                    <hr className={classes.visibleHR} />
                    <CommentForm soundOffId={soundOffId} />
                    <Comments comments={comments} />
                </Grid>
            )

        return (
            <React.Fragment>
                <MyButton tip='Expand' tipClassName={classes.expandButton} onClick={this.handleOpen}>
                    <UnfoldMore color='primary' />
                </MyButton>
                <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth='sm'>
                    <MyButton tip='Close' onClick={this.handleClose} btnClassName={classes.closeButton}>
                        <CloseIcon />
                    </MyButton>
                    <DialogContent className={classes.dialogContent}>
                        {dialogMarkup}
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        )
    }
}

SoundOffDialog.propTypes = {
    getSoundOff: PropTypes.func.isRequired,
    soundOffId: PropTypes.string.isRequired,
    userHandle: PropTypes.string.isRequired,
    soundOff: PropTypes.object.isRequired,
    UI: PropTypes.object.isRequired,
    clearErrors: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    soundOff: state.data.soundOff,
    UI: state.UI
});

const mapActionsToProps = {
    getSoundOff,
    clearErrors
}

export default connect(mapStateToProps, mapActionsToProps)(withStyles(styles)(SoundOffDialog));
